import React from 'react'
import { Flex, Text, Image } from '@chatterbug/aaron'
import { bronzeTutorIcon } from '../../assets'
import { BadgeType } from '../../types/index'

const Badge: React.FC<BadgeType> = ({ name, icon, image, url }) => {
  // far-eye doesn't get rendered, but fa-eye does
  // this function is a really poor way of removing the r from `far-eye`
  // there should not be invalid icons be provided by the backend
  const cleanFaIconString = (iconString: string): string => {
    if (iconString[2] === 'r') {
      let temp = iconString.split('')
      temp.splice(2, 1)
      return temp.join('')
    }
    return iconString
  }

  return (
    <Flex width="100%" justifyContent="center" alignSelf="flex-end">
      <Flex
        as="a"
        href={url}
        sx={{
          maxWidth: '100%',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap',
          cursor: 'pointer',
        }}
        css={`
          &:hover {
            /* because the fa icon has a weird underline */
            text-decoration: none !important;
          }
        `}
        key={name}
        flexDirection="column"
        alignItems="center"
        height="100%"
        justifyContent="flex-end "
      >
        {image && <Image width={50} src={image} alt="" />}
        {!image && icon && (
          <i
            className={`fa ${cleanFaIconString(icon)} fa-4x`}
            style={{ color: 'grey' }}
          />
        )}
        {!image && !icon && <Image src={bronzeTutorIcon} alt="" />}

        <Text
          mt="1x"
          variant="text.buttonTitle"
          color="gray46"
          fontWeight={400}
          sx={{
            maxWidth: '100%',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
          }}
        >
          {name}
        </Text>
      </Flex>
    </Flex>
  )
}

export default Badge
